export default {
    page_title: "Kevi | Estado del presupuesto",
    title: "Estado del presupuesto",
    save_button: "Guardar",
    status_updated: "Estados actualizados",
    status_options: {
        draft: "Borrador",
        sent: "Enviado",
        accepted: "Aprobado",
        rejected: "Rechazado",
        expired: "Expirado",
        cancelled: "Cancelado",
    },
};
